<script setup>
import HauptMenue from "../components/HauptMenue.vue";
import FooterMenu from "../components/FooterMenu.vue";
import AenderungsauftraegeSelfService from "../components/AenderungsauftraegeSelfService.vue";
import AuftraegeSelfService from "../components/AuftraegeSelfService.vue";
import Alertbox from "../components/Alertbox.vue";
import { store } from "../components/store.vue";
/** View-Komponente zur Anzeige verfügbarer Selfservices sowie nicht abgeholter Änderungsaufträge
 * @displayName Seite Auftragsübersicht Selfservices
 */
</script>
<script>
export default {
  name: "AuftragPensus",
  components: {
    // myRouter: router,
    HauptMenue,
    FooterMenu,
    AenderungsauftraegeSelfService,
    AuftraegeSelfService,
    Alertbox,
  },
  data() {
    return {
      inBearbeitung: {
        AenderungPersoenlichedaten: false,
        AenderungBankverbindung: false,
        ErfassungSteuerId: false,
        AenderungKontaktdaten: false,
        AntragBetriebsrente: false,
        AenderungKrankenkasse: false,
        AenderungAnsprechpartnerdaten: false,
        AenderungFirmendaten: false,
        AenderungFirmenAdressdaten: false,
        AenderungFirmenBankdaten: false,
        AenderungFirmenFinanzamtsdaten: false,
        KontaktPensus: false,
        Beitragsfreistellung: false,
        Wiederinkraftsetzung: false,
        Firmenaustritt: false,
        AenderungBeitrag: false,
      },
      unversandt: {
        AenderungPersoenlichedaten: false,
        AenderungBankverbindung: false,
        ErfassungSteuerId: false,
        AenderungKontaktdaten: false,
        AntragBetriebsrente: false,
        AenderungKrankenkasse: false,
        AenderungAnsprechpartnerdaten: false,
        AenderungFirmendaten: false,
        AenderungFirmenAdressdaten: false,
        AenderungFirmenBankdaten: false,
        AenderungFirmenFinanzamtsdaten: false,
        KontaktPensus: false,
        Beitragsfreistellung: false,
        Wiederinkraftsetzung: false,
        Firmenaustritt: false,
        AenderungBeitrag: false,
      },
      store,
      showSchnellzugriff: false,
    };
  },
  computed: {
    isWartung() {
      let wartung = false;
      let omessage = store.masterData.config?.messages?.Wartung ?? false;
      let now = new Date();
      if (
        omessage &&
        Date.parse(omessage.von) < now &&
        Date.parse(omessage.bis) > now
      ) {
        wartung = true;
      }
      return wartung;
    },
    messageWartung() {
      let message = "";
      if (this.isWartung) {
        message = store.masterData.config?.messages?.Wartung?.message ?? "";
      }
      return message;
    },
    isDbWartung() {
      let wartung = false;
      let omessage = store.masterData.config?.messages?.DBWartung ?? false;
      let now = new Date();
      if (
        omessage &&
        Date.parse(omessage.von) < now &&
        Date.parse(omessage.bis) > now
      ) {
        wartung = true;
      }
      return wartung;
    },
    messageDbWartung() {
      let message = "";
      if (this.isDbWartung) {
        message = store.masterData.config?.messages?.DBWartung?.message ?? "";
      }
      return message;
    },
  },
  methods: {
    chckUnbearbeitet() {
      for (const [key] of Object.entries(this.inBearbeitung)) {
        //console.log("->subData.draft.sService.Entwuerfe." + key);
        this.inBearbeitung[key] =
          this.$servertalk.gettAttr(
            "subData.draft.sService.Entwuerfe." + key
          ) == "modified" ||
          this.$servertalk.gettAttr(
            "masterData.draft.sService.Entwuerfe." + key
          ) == "modified";
        this.unversandt[key] =
          this.$servertalk.checkForUnsentSelfService(key) ||
          this.$servertalk.checkForUnsentSelfService(key, store.subData);
      }
    },
  },
  watch: {
    "store.subData.draft.sService.Entwuerfe": {
      handler() {
        this.chckUnbearbeitet();
      },
      deep: true,
    },
    "store.masterData.draft.sService.Entwuerfe": {
      handler() {
        this.chckUnbearbeitet();
      },
      deep: true,
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$servertalk.doLog("Inhalt Store:", store);
    this.chckUnbearbeitet();
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
    this.showSchnellzugriff = true;
  },
};
</script>
<template>
  <main class="main-wrapper flex-grow" :class="store.accessRestriction">
    <HauptMenue />
    <div class="mt-36 md:mt-48 lg:mt-56 mb-32 max-w-7xl mx-auto px-5 2xl:px-0">
      <h1
        class="text-primary/75 font-bold text-2xl lg:text-4xl text-center mb-8 sm:mb-16 uppercase">
        Ihr Auftrag an uns
      </h1>
      <Alertbox />
      <div
        v-if="isWartung"
        class="p-5 text-primary border border-primary bg-primary/10 rounded-md my-5 max-w-3xl mx-auto">
        {{ messageWartung }}
      </div>
      <div
        v-if="isDbWartung"
        class="p-5 text-primary border border-primary bg-primary/10 rounded-md my-5 max-w-3xl mx-auto">
        {{ messageDbWartung }}
      </div>
      <div class="unversandt">
        <AenderungsauftraegeSelfService @removed="chckUnbearbeitet" />
      </div>
      <div
        class="grid gap-5 md:grid-cols-2 xl:grid-cols-3 [&>.item>a>.item-text]:uppercase [&>.item>a>.item-text]:font-bold [&>.item>a>.item-text]:text-center [&>.item>a>.item-text]:px-2 [&>.item>a>.item-text]:text-white [&>.item>a>.item-text]:transition-all [&>.item>a>.item-text]:duration-500 [&>.item>a>.item-text]:py-2 [&>.item>a>.item-image]:border-t [&>.item>a>.item-image]:border-primary">
        <AuftraegeSelfService
          v-bind:nurOffene="false"
          v-bind:fuerMitarbeiter="false"
          v-model:unversandt="unversandt"
          v-model:inBearbeitung="inBearbeitung" />
      </div>
    </div>
  </main>
  <FooterMenu />
</template>
